export const environment = {
    production: false,
    API_URL : "https://api.platform-mvm.maverick.paris/api/"
};
